<template>
  <div>

    <div class="row" :class="{'mt-30':quizSlug}" v-if="quizObj && quizObj.quiz">
      <div class="col-xs-12 mb-10" v-show="!quizSlug">
        <h1>{{quizObj.quiz.title}}</h1>
      </div>
      <div :class="{'col-lg-2 col-md-3 col-sm-5 col-xs-5':!quizSlug,'col-xs-4':quizSlug}">
          <div class="col-xs-12 p-0">
            <span class="dashboard-stat dashboard-stat-v2 green nb_participants">
                <div class="visual">
                    <i class="fa fa-bar-chart-o"></i>
                </div>
                <div class="details">
                    <div class="number" v-if="quizObj.quiz && quizObj.quiz.responses">
                        <span data-counter="counterup" :data-value="quizObj.nbResponses()">{{quizObj.nbResponses()}}</span>
                    </div>
                    <div class="desc"> Réponses </div>
                </div>
            </span>
          </div>
          <div class="col-xs-12 p-0 mt-10">
            <span class="dashboard-stat dashboard-stat-v2 yellow nb_participants">
                <div class="visual">
                    <i class="fa fa-group"></i>
                </div>
                <div class="details">
                    <div class="number" v-if="!Number.isNaN(nbParticipants)">
                      <span data-counter="counterup" :data-value="nbParticipants"></span>{{nbParticipants}}
                    </div>
                    <div class="number" v-else>
                      <img src='/static/img/infinite.svg' style='width:40px;' alt='symbole infini'/>
                    </div>
                    <div class="desc"> Participants</div>
                </div>
            </span>
          </div>
      </div>

      <div :class="{'col-lg-4 col-md-9 col-sm-12 col-xs-12':!quizSlug,'col-xs-8':quizSlug}">
          <!-- BEGIN WIDGET THUMB -->
          <div class="widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter">
              <h4 class="widget-thumb-heading text-uppercase ">Statistique par groupe</h4>
              <div class="widget-thumb-wrap">
                  <div :id="'chartdiv'+number" class="graph_stat_group"></div>
              </div>
          </div>
          <!-- END WIDGET THUMB -->
      </div>

      <div :class="{'col-lg-3':!quizSlug,'col-xs-6':quizSlug}">
          <!-- BEGIN WIDGET THUMB -->
          <div class="widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter">
              <h4 class="widget-thumb-heading text-uppercase">Filtre</h4>
              <div class="widget-thumb-wrap">
                <div class="mt-checkbox-list">
                    <label class="mt-checkbox" v-for="group in quizObj.quiz.groups">
                        <input type="checkbox" :value="group" v-model="quizObj.filters" v-on:change="refresh()"> {{group.name}}
                        <span></span>
                    </label>
                </div>
              </div>
          </div>
          <!-- END WIDGET THUMB -->
      </div>

      <div :class="{'col-lg-3':!quizSlug,'col-xs-6':quizSlug}">

          <!-- BEGIN WIDGET THUMB -->
          <div class="widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions">
              <h4 class="widget-thumb-heading  text-uppercase">Actions</h4>

              <!-- <div class="btn-group">
                <button class="btn btn-circle blue dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"> Préconisations d'actions
                    <i class="fa fa-angle-down"></i>
                </button>
                <ul class="dropdown-menu" role="menu">
                    <li>
                        <a href="javascript:;"> Nouveau </a>
                    </li>
                    <li>
                        <a href="javascript:;"> Editer </a>
                    </li>
                    <li>
                        <a href="javascript:;"> Liste </a>
                    </li>
                </ul>
            </div> -->
            <div class="row p-0">
              <div class="col-md-12 col-sm-6 col-xs-6 mb-10">
                <router-link :to="{name:'quizzes_edit',params:{slug:quizObj.quiz.slug}}" class="btn btn-circle white">
                  <i class="fa fa-share"></i>
                  Partager le formulaire
                </router-link>
              </div>

              <!-- <hr class="col-md-8 col-md-offset-2 hidden-sm hidden-xs" style="border-style:dashed;border-color:#bdbcbc;margin-top:15px;margin-bottom:15px;"> -->

              <div class="col-md-12 col-sm-6 col-xs-6 mb-10">
                <router-link :to="{name:'quizzes_preconizations', params:{slug:quizObj.quiz.slug}}" class="btn btn-circle green">
                  <i class="fa fa-gear"></i>
                  Préconisations et analyses
                </router-link>
              </div>
              <div class="col-md-12 col-sm-6 col-xs-6 mb-10">
                <a :href="file_responses.href" :download="file_responses.name" class="btn btn-circle yellow" title="Télécharger les questions ouvertes">
                  <i class="fa fa-download fs-20" aria-hidden="true"></i> Télécharger QO
                </a>
              </div>
              <div class="col-md-12 col-sm-6 col-xs-6 mb-10">
                <a :href="file_participants.href" :download="file_participants.name" class="btn btn-circle yellow" title="Télécharger la liste des participants">
                <i class="fa fa-download fs-20" aria-hidden="true"></i> Télécharger liste des participants
                </a>
              </div>

              <div class="col-md-12 col-sm-6 col-xs-6">
                <router-link :to="{name:'quizzes_export_pdf',params:{slug:quizObj.quiz.slug}}" class="btn btn-circle yellow" title="Rapport PDF"><i class="fa fa-print fs-20" aria-hidden="true"></i> Export PDF </router-link>
              </div>

            </div>
          </div>
          <!-- END WIDGET THUMB -->

      </div>

    </div>

    <div class="row">

      <div class="col-lg-12" v-if="quizObj && quizObj.quiz">
          <!-- BEGIN VALIDATION STATES-->
          <div id="testExportPdf" class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ">
              <div class="portlet-title col-xs-12 ">
                  <div class="caption tabbable-line p-0">
                      <ul class="nav nav-tabs ">
                          <li class="active">
                              <a data-toggle="tab" aria-expanded="true" v-on:click="show.graph = true">
                                <i class=" icon-pie-chart"></i>
                                <span class="caption-subject sbold uppercase">Synthèse</span>
                              </a>
                          </li>
                          <li class="">
                              <a data-toggle="tab" aria-expanded="false" v-on:click="show.tab = true">
                                <i class=" icon-list"></i>
                                <span class="caption-subject sbold uppercase">Tableau QO</span>
                              </a>
                          </li>
                          <li class="">
                              <a data-toggle="tab" aria-expanded="false" v-on:click="show.participants = true">
                                <i class=" icon-users"></i>
                                <span class="caption-subject sbold uppercase">Participants </span>
                              </a>
                          </li>
                      </ul>


                  </div>
              </div>
              <div class="portlet-body col-xs-12 mb-30" v-if="quizObj.quiz.questions">
                <div class="col-xs-12 text-right mt-10" v-if="show.graph && quizObj.quiz.responses.length > 0 && nbQuestionsOpenOutMultiple < quizObj.quiz.questions.length">
                  <a @click="changeAllGraphType('simple');" class="btn btn-xs default">Graphiques simples</a>
                  <a @click="changeAllGraphType('détaillé');" class="btn btn-xs default">Graphiques détaillés</a>
                  <a @click="changeAllLegendesType('below');" class="btn btn-xs default">Légendes en dessous</a>
                  <a @click="changeAllLegendesType('above');" class="btn btn-xs default">Légendes superposées</a>
                </div>
                <div v-show="show.graph" v-for="(question,index) in quizObj.quiz.questions">
                  <div v-if="question.type != 'text' ">
                    <div class="mt-element-ribbon col-xs-12 p-0">
                      <div class="ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase">
                        <div class="ribbon-sub ribbon-clip"></div> Question n°{{index+1}}
                      </div>
                    </div>
                    <div class="col-xs-12 p-0 ml-10" style="margin-top:-20px;">
                      <a @click="changeGraphType(question);" class="btn btn-xs default">Graphique {{question.graphType}} <span v-if="!question.graphType">détaillé</span></a>
                      <a @click="changeLegendeType(question);" class="btn btn-xs default">Légende <span v-if="!question.legendeType || question.legendeType == 'below'">superposée</span><span v-else>en dessous</span></a>
                    </div>

                    <div class="col-xs-12 p-0 text-center">
                      <h3>{{question.title}}</h3>
                      <div :id="'container'+question.id+'-'+number" class="graph" style="margin-top:30px;">Aucune réponse</div>
                    </div>
                    <div class="col-xs-12 p-0 text-center mt-30" v-for="data in question.data" v-if="data.question && data.question.title && data.question.type != 'text'">
                      <h4>{{ data.name }} - {{data.question.title}}</h4>
                      <div class="text-left ml-10">
                        <a @click="changeGraphType(data.question,question);" class="btn btn-xs default">Graphique {{data.question.graphType}} <span v-if="!data.question.graphType">détaillé</span></a>
                        <a @click="changeLegendeType(data.question,question);" class="btn btn-xs default">Légende <span v-if="!data.question.legendeType || data.question.legendeType == 'below'">superposée</span><span v-else>en dessous</span></a>
                      </div>
                      <div :id="'container_child'+data.id+'-'+number" class="graph" style="margin-top:30px;">Aucune réponse</div>
                    </div>
                  </div>
                </div>
                <div v-if="show.graph && nbQuestionsOpenOutMultiple >= quizObj.quiz.questions.length" class="col-xs-12 m-30">
                  Ce questionnaire ne contient que des questions ouvertes !
                </div>
                <div class="col-xs-12 text-right" v-if="show.graph && quizObj.quiz.responses.length > 0 && nbQuestionsOpenOutMultiple < quizObj.quiz.questions.length">
                  <a @click="changeAllGraphType('simple');" class="btn btn-xs default">Graphiques simples</a>
                  <a @click="changeAllGraphType('détaillé');" class="btn btn-xs default">Graphiques détaillés</a>
                  <a @click="changeAllLegendesType('below');" class="btn btn-xs default">Légendes en dessous</a>
                  <a @click="changeAllLegendesType('above');" class="btn btn-xs default">Légendes superposées</a>
                </div>
                <div v-show="show.tab">
                  <div class="col-xs-12" v-if="nbQuestionsOpen > 0">
                    <list :columns="columns" :dataSet="dataSet" :id="'qo'+number"></list>
                  </div>
                  <div class="col-xs-12" v-if="nbQuestionsOpen <= 0">
                      Ce questionnaire ne contient pas de questions ouvertes !
                  </div>
                </div>
                <div v-show="show.participants">
                  <div class="col-xs-12" v-if="quizObj.quiz.responses.length > 0">
                    <list :columns="columnsParticipants" :dataSet="dataSetParticipants" :id="'participants'+number"></list>
                  </div>
                  <div class="col-xs-12" v-if="quizObj.quiz.responses.length <= 0">
                      Ce questionnaire ne contient aucune réponse.
                  </div>
                </div>
              </div>
              <div class="col-xs-12 p-0 text-center" v-if="!quizObj.quiz.questions || (quizObj.quiz.questions && quizObj.quiz.questions.length <= 0)">
                <h3>Aucune questions à ce questionnaire !</h3>
              </div>
          </div>
          <!-- END VALIDATION STATES-->
      </div>

      <div class="row m-0" v-else>
        <div class="col-md-12 page-404 mt-50">
            <div class="number font-green"> 404 </div>
            <div class="details">
                <h3>Oops ! Questionnaire non trouvé.</h3>
                <p> Nous n'avons pas réussi à trouver ce questionnaire.
                    <br>
                    Vérifiez l'url et tentez de recharger la page.
                </p>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>

  import quizzes from '../../requests/quizzes.js'
  // var config = require('../../config/settings.json');
  import List from '../others/list.vue'

  import Quiz from '../../store/quiz.js'

  export default {
    props:["number","quizSlug"],
    components: {
      List
    },
    data(){
      return{
        quizObj:{
          quiz:{}
        },
        filters:[],
        show:{
          graph:true,
          tab:false,
          participants:false
        },
        columns:[],
        dataSet:[],
        columnsParticipants:[],
        dataSetParticipants:[],
        file_responses:{
          name:"",
          href:""
        },
        file_participants:{
          name:"",
          href:""
        }
      }
    },
    watch:{
      'show.graph':function(){
        if(this.show.graph){
          this.show.tab = false;
          this.show.participants = false;
        }
      },
      'show.tab':function(){
        if(this.show.tab){
          this.show.graph = false;
          this.show.participants = false;
        }
      },
      'show.participants':function(){
        if(this.show.participants){
          this.show.graph = false;
          this.show.tab = false;
        }
      },
      'quizSlug':function(){
        this.reinit();
        this.init();
      }
    },
    computed:{
      nbQuestionsOpenOutMultiple:function(){
        return this.quizObj.nbQuestionsOpenOutMultiple ? this.quizObj.nbQuestionsOpenOutMultiple() : 0;
      },
      nbQuestionsOpen:function(){
        return this.quizObj.nbQuestionsOpen ? this.quizObj.nbQuestionsOpen() : 0;
      },
      nbParticipants: function(){
        return this.quizObj.nbParticipants ? this.quizObj.nbParticipants() : 0;
      }
    },
    mounted:function(){
      this.init();
    },
    methods:{
      reinit(){
        this.quizObj = {
          quiz:{}
        };
        this.columns = [],
        this.dataSet = [],
        this.columnsParticipants = [];
        this.dataSetParticipants = [];
        this.file_responses = {
          name:"",
          href:""
        }
        ,
        file_participants = {
          name:"",
          href:""
        }
      },
      init(){
        var parent = this;
        var slugQuiz = this.quizSlug ? this.quizSlug : this.$route.params.slug;
        new Quiz(this,slugQuiz,this.number,function(err,quizObj){
          if(quizObj){
            parent.quizObj = quizObj;
            parent.createChart();
          }
        });
      },
      refresh(){
        this.quizObj.statsResponses();
        this.statsGroups();
        this.prepareList();
        this.prepareListParticipants();
      },
      createCSV(columns,dataSet,file){
        var csvContent = ""
        for(var i=0;i<columns.length;i++){
          csvContent += columns[i].title +";";
        }
        csvContent += "\n";
        for(var a=0;a<dataSet.length;a++){
          var dataString = "";
          for(var c=0;c<columns.length;c++){
            // Vérifier qu'il n'y est pas de , ou ; dans la valeur sinon le formattage d'excel va buguer.
            var val = dataSet[a][c].toString();
            if(dataSet[a][c].toString().indexOf("<span") >= 0){
                // On enleve la balise qu'on a rajouté précédemment.
                var index_first = val.indexOf(">");
                var index_last = val.lastIndexOf("<");
                val = val.substring(index_first+1,index_last)
            }

            if(val.indexOf(",") <= 0 || val.indexOf(";") <= 0){
              dataString += '"'+val + '"' + ";";
            }
            else{
              dataString += val + ";";
            }
          }
          dataString += "\n";
          csvContent += dataString;
        }

        file.href = "data:text/csv;charset=UTF-8,%ef%bb%bf"+encodeURI(csvContent);
        if(!file.name){
          file.name = this.quizObj.quiz.slug;
        }
      },
      statsGroups(){
        var dataProvider = this.quizObj.statsGroups();
        var chart = AmCharts.makeChart( "chartdiv"+ this.number, {
          "type": "pie",
          "theme": "light",
          "dataProvider": dataProvider,
          "valueField": "participants",
          "titleField": "groupe",
           "balloon":{
           "fixedPosition":true
          },
          "export": {
            "enabled": false
          }
        });
      },
      changeAllGraphType(type){
        for(var q=0;q<this.quizObj.quiz.questions.length;q++){
          this.$set(this.quizObj.quiz.questions[q], 'graphType', type);
          for(let d=0;d<this.quizObj.quiz.questions[q].data.length;d++){
            if(this.quizObj.quiz.questions[q].data[d].question){
              this.$set(this.quizObj.quiz.questions[q].data[d].question,'graphType',type);
            }
          }
        }
        this.quizObj.statsResponses();
      },
      changeAllLegendesType(type){
        for(var q=0;q<this.quizObj.quiz.questions.length;q++){
          this.$set(this.quizObj.quiz.questions[q], 'legendeType', type);
          for(let d=0;d<this.quizObj.quiz.questions[q].data.length;d++){
            if(this.quizObj.quiz.questions[q].data[d].question){
              this.$set(this.quizObj.quiz.questions[q].data[d].question,'legendeType',type);
            }
          }
        }
        this.quizObj.statsResponses();
      },
      changeGraphType(question,questionParent){
        if(question.graphType == "simple"){
          this.$set(question, 'graphType', "détaillé");
        }
        else{
          this.$set(question, 'graphType', "simple");
        }
        // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
        questionParent = questionParent ? questionParent : question;
        this.quizObj.statsResponses(questionParent);
      },
      changeLegendeType(question,questionParent){
        if(!question.legendeType || question.legendeType == "below"){
          this.$set(question, 'legendeType', "above");
        }
        else{
          this.$set(question, 'legendeType', "below");
        }
        // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
        questionParent = questionParent ? questionParent : question;
        this.quizObj.statsResponses(questionParent);
      },
      createChart(){
        var parent = this;
        this.$nextTick(function () {
          parent.statsGroups();
          parent.quizObj.statsResponses();
          parent.prepareList();
          parent.prepareListParticipants();
        })
      },
      prepareList(){
        var res = this.quizObj.prepareList();
        this.dataSet = res.dataSet;
        this.columns = res.columns;

        this.file_responses.name = this.quizObj.quiz.slug +"_QO.csv"
        this.createCSV(this.columns,this.dataSet,this.file_responses);
      },
      prepareListParticipants(){
        var res = this.quizObj.prepareListParticipants();
        this.dataSetParticipants = res.dataSetParticipants;
        this.columnsParticipants = res.columnsParticipants;

        this.file_participants.name = this.quizObj.quiz.slug +"_participants.csv"
        this.createCSV(this.columnsParticipants,this.dataSetParticipants,this.file_participants);
      }
    }
  }
</script>
<style scoped>
  .link_share{
    color:#5f524c
  }

  .graph_stat_group {
    width: 100%;
    height: 200px;
  }

  .graph {
  	max-width: 660px;
  	margin: auto;
  	max-height: 400px;
  	margin: 0 auto;
  }

  .nb_participants{
    padding-top: 9px;
  }

  .bloc_filter{
    height: 287px;
    overflow: auto;
  }


  .bloc_actions{
    height: 287px;
    overflow: auto;
  }

  @media (max-width: 991px){
    .bloc_actions{
      height: auto;
    }
  }

  .dashboard-stat{
    margin-bottom: 19px;
  }

</style>

<style src="../../assets/theme/css/error.min.css"></style>



// WEBPACK FOOTER //
// responses.vue?ed435bf8